(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-list"] && !Shopify.designMode) return;
  try {
    
  class FeatureCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.feature-carousel__track');
      this.slides = Array.from(this.track.children);
      this.dots = Array.from(this.querySelectorAll('.feature-carousel__dot'));
      this.smooth = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

      const prev = this.querySelector('.feature-carousel__arrow--prev');
      const next = this.querySelector('.feature-carousel__arrow--next');
      if (prev) prev.addEventListener('click', () => this.goTo(this.current() - 1));
      if (next) next.addEventListener('click', () => this.goTo(this.current() + 1));

      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));

      this.track.addEventListener('scroll', () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = null;
          this.updateDots();
        });
      });

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', (e) => {
          const i = this.slides.findIndex((s) => s.contains(e.target) || s === e.target);
          if (i >= 0) this.goTo(i);
        });
      }
    }

    current() {
      return Math.round(this.track.scrollLeft / this.track.clientWidth);
    }

    goTo(index) {
      const n = this.slides.length;
      const i = ((index % n) + n) % n;
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: this.smooth });
    }

    updateDots() {
      const i = this.current();
      this.dots.forEach((dot, d) => dot.classList.toggle('is-active', d === i));
    }
  }

  if (!customElements.get('feature-carousel')) {
    customElements.define('feature-carousel', FeatureCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-tabs"] && !Shopify.designMode) return;
  try {
    
  class FeatureTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.index = 0;

      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.activate(i));
        tab.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') this.activate((i + 1) % this.tabs.length, true);
          if (e.key === 'ArrowLeft') this.activate((i - 1 + this.tabs.length) % this.tabs.length, true);
        });
      });

      const prev = this.querySelector('.feature-tabs__arrow--prev');
      const next = this.querySelector('.feature-tabs__arrow--next');
      if (prev) prev.addEventListener('click', () => this.activate((this.index - 1 + this.tabs.length) % this.tabs.length));
      if (next) next.addEventListener('click', () => this.activate((this.index + 1) % this.tabs.length));

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', (e) => {
          const i = this.tabs.findIndex((tab) => tab.contains(e.target) || tab === e.target);
          if (i >= 0) this.activate(i);
        });
      }
    }

    activate(index, focus = false) {
      this.index = index;
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
        if (active) {
          tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
          if (focus) tab.focus();
        }
      });
      this.panels.forEach((panel, i) => {
        panel.hidden = i !== index;
        panel.classList.toggle('is-active', i === index);
      });
    }
  }

  if (!customElements.get('feature-tabs')) {
    customElements.define('feature-tabs', FeatureTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  class TestimonialsSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.testimonials__track');
      if (!this.track) return;
      this.smooth = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

      const step = () => {
        const card = this.track.firstElementChild;
        if (!card) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      };
      const prev = this.querySelector('.testimonials__arrow--prev');
      const next = this.querySelector('.testimonials__arrow--next');
      // halve kaartbreedte tolerantie: scroll-snap parkeert niet altijd exact op de rand
      const atStart = () => this.track.scrollLeft < step() / 2;
      const atEnd = () => this.track.scrollLeft + this.track.clientWidth > this.track.scrollWidth - step() / 2;
      if (prev) prev.addEventListener('click', () => {
        if (atStart()) {
          this.track.scrollTo({ left: this.track.scrollWidth, behavior: this.smooth });
        } else {
          this.track.scrollBy({ left: -step(), behavior: this.smooth });
        }
      });
      if (next) next.addEventListener('click', () => {
        if (atEnd()) {
          this.track.scrollTo({ left: 0, behavior: this.smooth });
        } else {
          this.track.scrollBy({ left: step(), behavior: this.smooth });
        }
      });

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', (e) => {
          const card = e.target.closest('.testimonials__card');
          if (card && this.contains(card)) {
            card.scrollIntoView({ block: 'nearest', inline: 'center', behavior: this.smooth });
          }
        });
      }
    }
  }

  if (!customElements.get('testimonials-slider')) {
    customElements.define('testimonials-slider', TestimonialsSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
